'use client';
import Accordion, { FormattedAccordion } from 'components/Accordion';
import { ReactElement, SetStateAction, useState } from 'react';

interface AccordionGroupProps {
  accordions: FormattedAccordion[];
  firstExpandedEnabled?: boolean;
}

export default function AccordionGroup({
  accordions,
  firstExpandedEnabled,
}: AccordionGroupProps): ReactElement {
  const [isExpanded, setIsExpanded] = useState<SetStateAction<null | number>>(
    firstExpandedEnabled ? 0 : null
  );

  const toggleExpanded = (index: null | number) => {
    setIsExpanded(index);
  };

  return (
    <>
      {accordions.map((accordion, index) => (
        <Accordion
          categoryTag={accordion.categoryTag}
          externalCtaText={accordion?.externalCtaText || ''}
          externalCtaUrl={accordion?.externalCtaUrl || ''}
          headline={accordion.headline}
          index={index}
          isExpanded={isExpanded === index}
          key={accordion.headline}
          libraryPageSlug={accordion?.libraryPageSlug || ''}
          summary={accordion.summary}
          toggleExpanded={toggleExpanded}
        />
      ))}
    </>
  );
}
